/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Map_Refresh_LoadingInputs */

const fr_map_refresh_loading = /** @type {(inputs: Map_Refresh_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rafraichissement en cours...`)
};

const en_map_refresh_loading = /** @type {(inputs: Map_Refresh_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Refreshing...`)
};

/**
* | output |
* | --- |
* | "Refreshing..." |
*
* @param {Map_Refresh_LoadingInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const map_refresh_loading = /** @type {((inputs?: Map_Refresh_LoadingInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Map_Refresh_LoadingInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_map_refresh_loading(inputs)
	return en_map_refresh_loading(inputs)
});